import {
  FieldConfiguration,
  GroupingField,
  Ordering,
  ReportField,
  SortConfiguration,
  SortField,
} from "../../../../../shared/reporting/api/biClient.types";
import { isNotAggregatedDimension } from "../../../../../shared/reporting/utils/fieldsHelper.ts";
import cloneDeep from "../../../../../shared/utilities/cloneDeep";

export const setGroupingFlag = (fields: FieldConfiguration[], groups: GroupingField[], sorts: SortConfiguration[]) => {
  const groupIds = new Set(groups.map((g) => g.id));
  const copy = cloneDeep(sorts);

  copy.forEach((sorting) => {
    const field = fields.find((f) => f.guid === sorting.id);
    if (field && groupIds.has(field.guid)) {
      sorting.isGroupField = true;
    }
  });

  return copy;
};

export const addMissingGroupSorts = (
  fields: FieldConfiguration[],
  groups: GroupingField[],
  sorts: SortConfiguration[]
) => {
  const groupIds = new Set(groups.map((g) => g.id));
  const sortMetaNames = new Set(sorts.map((s) => s.id));

  const missingSorts = fields
    .filter((field) => groupIds.has(field.guid) && !sortMetaNames.has(field.guid))
    .map(
      (field) =>
        ({
          name: field.name,
          isGroupField: true,
          ordering: Ordering.Ascending,
          caption: field.customLabel ?? field.name,
          id: field.guid,
        }) as SortConfiguration
    );

  return [...cloneDeep(sorts), ...missingSorts];
};

export const sortSortingFields = (sorts: SortField[], groupMetaNames: string[]) => {
  const groupedFields = sorts.filter((field) => field.config.isGroupField);
  const regularFields = sorts.filter((field) => !field.config.isGroupField);

  groupedFields.sort(
    (a, b) => groupMetaNames.findIndex((g) => g === a.meta.name) - groupMetaNames.findIndex((g) => g === b.meta.name)
  );

  return [...groupedFields, ...regularFields];
};

export const getAvailableSortFields = (values: ReportField[], sortingAreaValues: SortField[]) => {
  return values
    .filter(isNotAggregatedDimension)
    .filter((f) => !sortingAreaValues.find((v) => v.config.id === f.config.guid));
};
